import BaseModel from '../../base';

export default class TeamRole extends BaseModel {
  constructor(role = {}, url = 'team-roles') {
    super(role, url);

    Object.assign(this, role);

    this.description = role.description || null;
    this.min_members = role.min_members ?? role.pivot?.min_members ?? null;
    this.max_members = role.max_members ?? role.pivot?.max_members ?? null;
  }
}
